/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "styled-components";
import DialogContentText from "@material-ui/core/DialogContentText";

const StyledDialogContentText = styled(({ ...props }) => (
  <DialogContentText {...props} />
))`
  && {
  }
`;

export { StyledDialogContentText };
